import React from 'react';
import styled from 'styled-components';
import SectionCard from './SectionCard';
import FieldDisplay from './FieldDisplay';
import DataTable from './DataTable';
import { EquityHolder } from '../types';

const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;

interface AboutBusinessSectionProps {
  legalBusinessName?: string;
  dba?: string;
  industry?: string;
  yearFounded?: number;
  equityHolders?: EquityHolder[];
}

const equityHolderColumns = [
  { key: 'firstName', label: 'First Name' },
  { key: 'lastName', label: 'Last Name' },
  { key: 'percentOwnership', label: 'Ownership %' },
];

const formatEquityHolderRows = (equityHolders?: EquityHolder[]) => {
  if (!equityHolders || equityHolders.length === 0) return [];
  return equityHolders.map(holder => ({
    firstName: holder.firstName,
    lastName: holder.lastName,
    percentOwnership: holder.percentOwnership != null ? `${holder.percentOwnership}%` : '-',
  }));
};

const AboutBusinessSection: React.FC<AboutBusinessSectionProps> = ({
  legalBusinessName,
  dba,
  industry,
  yearFounded,
  equityHolders,
}) => (
  <SectionCard title="Business Information">
    <FieldsGrid>
      <FieldDisplay label="Legal Business Name" value={legalBusinessName} />
      <FieldDisplay label="DBA" value={dba} />
      <FieldDisplay label="Industry" value={industry} />
      <FieldDisplay label="Year Founded" value={yearFounded} />
    </FieldsGrid>
    <DataTable
      title="Equity Holders"
      columns={equityHolderColumns}
      rows={formatEquityHolderRows(equityHolders)}
      emptyMessage="No equity holders listed"
    />
  </SectionCard>
);

export default AboutBusinessSection;
